import _ from 'lodash';

export const NavigationMenuGroupItemTestIds = {
  ITEM: 'nav-menu-group.item-button',

  // Dynamic
  getSubmenuId: title => `header-nav.${_.kebabCase(title)}-submenu`,
  getLinkId: title => `header-nav.${_.kebabCase(title)}-link`,
};
